export enum AccountStatus {
  ContractorInformationNeeded = 'Contractor Information Needed',
  MdaNeeded = 'MDA Needed',
  IntakeNeeded = 'Intake Needed',
  Complete = 'Complete',
}

export enum SectionStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  Active = 'Active',
  Disabled = 'Disabled',
}

export enum StatusSectionName {
  ContractorRegistration = 'Contractor Registration',
  MasterDealerAgreement = 'Master Dealer Agreement',
  IntakeMeeting = 'Intake Meeting',
}
